import { ADDRESS_URL, DELETE_USER_URL, FORGOT_PASSWORD_URL, LOGIN_URL, LOGOUT_URL, REGISTER_URL, RESET_PASSWORD_URL, USER_URL} from "../../../../../constants";
import { apiSlice } from "./apiSlice";

export const userApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (data) => ({
                url: LOGIN_URL,
                method: 'POST',
                body: data 
            })
        }),
        logout: builder.mutation({
            query: (data) => (
                {
                url: LOGOUT_URL,
                method: 'GET',
                headers: {
                    Authorization: data.token ? `Bearer ${data.token}` : '', 
                },
            }),
        }),
        delete: builder.mutation({
            query: (data) => (
                {
                url: DELETE_USER_URL,
                method: 'DELETE',
                headers: {
                    Authorization: data.token ? `Bearer ${data.token}` : '', 
                },
            }),
        }),
        register: builder.mutation({
            query: (data) => ({
                url: REGISTER_URL,
                method: 'POST',
                body: data
            }),
        }),
        user: builder.query({
            query: (data) => (
                {
                url: USER_URL,
                method: 'GET',
                headers: {
                    Authorization: data.token ? `Bearer ${data.token}` : '', 
                },
            }),
        }),
        address: builder.query({
            query: (data) => (
                {
                url: ADDRESS_URL,
                method: 'GET',
                headers: {
                    Authorization: data.token ? `Bearer ${data.token}` : '', 
                },
            }),
        }),
        forgotPassword: builder.mutation({
            query: (data) => ({
                url: FORGOT_PASSWORD_URL,
                method: 'POST',
                body: data 
            })
        }),
        resetPassword: builder.mutation({
            query: (data) => ({
                url: RESET_PASSWORD_URL,
                method: 'POST',
                body: data 
            })
        }),
    }),
})

export const {
    useLoginMutation, 
    useLogoutMutation,
    useDeleteMutation, 
    useRegisterMutation,
    useUserQuery,     
    useAddressQuery,
    useForgotPasswordMutation,
    useResetPasswordMutation

} = userApiSlice;